import { ResourceInfoProvider } from '@openx/components-core/lib/Form/context/ResourceInfoContext';
import type { PackageFormState } from '@openx/types/package';
import type { JSX } from 'react';
import { usePackageContext } from '../../utils/context/PackageContext';
import { DPackageRates } from './sections/DPackageRates';
import { MerchandisingDetails } from './sections/MerchandisingDetails';
import { OnBehalfOf } from './sections/OnBehalfOf';
import { PackageDetails } from './sections/PackageDetails';
import { PMPackageRates } from './sections/PMPackageRates';
import { TargetingCriteria } from './sections/TargetingCriteria';
import { UsedBySection } from './sections/UsedBy/UsedBySection';

export type PackageDetailsTabProps = { pckg: PackageFormState };

export const PackageDetailsTab = ({ pckg }: PackageDetailsTabProps): JSX.Element => {
  const { usePackagePermissions, isOa } = usePackageContext();

  const { isInternalUser } = usePackagePermissions();
  const hideSectionForOaExternal = !isOa || isInternalUser;

  return (
    <ResourceInfoProvider name="package">
      {hideSectionForOaExternal && <OnBehalfOf pckg={pckg} />}
      <PackageDetails pckg={pckg} />
      <UsedBySection isCurated={pckg.is_curated} />
      {hideSectionForOaExternal && <MerchandisingDetails pckg={pckg} />}
      <TargetingCriteria pckg={pckg} />
      <DPackageRates pckg={pckg} />
      {hideSectionForOaExternal && <PMPackageRates pckg={pckg} />}
    </ResourceInfoProvider>
  );
};
